
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perfil/configuracion/historial-busquedas",
      function () {
        return require("private-next-pages/perfil/configuracion/historial-busquedas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perfil/configuracion/historial-busquedas"])
      });
    }
  